<div class="card-wrapper" [ngClass]="{'disable-padding':disablePadding(), 'disable-tinting':disableTinting(), 'card-wrapper-shape': textTitle() || textDescr()}">
	@if (textTitle() || textDescr()) {
		<div class="card-title">
			@if (textTitle()) {
				<div class="title-header">{{ textTitle() }}</div>
			}

			@if (textDescr()) {
				<div class="title-descr">
					@for (row of textDescr(); track row + $index) {
						<div class="title-descr-row">
							&nbsp;
							{{ row }}
						</div>
					}
				</div>
			}
		</div>
	}
	<div class="card-body" [ngClass]="{'content-layer-t': clipPathT(), 'content-layer-b': clipPathB()}">
		<ng-content></ng-content>
	</div>
</div>